import axios from "axios";
import { apiUrl } from "config";

export const fetchWalletTraits = async (address: string): Promise<number[]> => {
  const res = await axios.get<{ tokenId: number; quantity: number }[]>(
    `/wallet/${address}/traits`,
    {
      baseURL: apiUrl,
    }
  );

  return res.data
    .filter(({ quantity }) => quantity > 0)
    .map(({ tokenId }) => tokenId);
};
